var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowitworksshape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 394.072 705.153",
    enableBackground: "new 0 0 394.072 705.153",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guides",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00FAB0",
    d: "M78.765,167.717c-8.981,56.137-44.503,119.154-60.967,148.373l1.206,4.454 c33.396-44.028,145.516-195.087,214.174-199.394c41.16-2.583,70.16,6.08,89.576,16.807C291.525,48.184,222.947-8.75,152.367,1.104 l-35.146,4.907C54.924,14.708,11.93,75.09,0,155.006C41.032,133.105,86.295,120.667,78.765,167.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00FAB0",
    d: "M339.674,213.565c-4.081,1.838-8.579,3.76-13.574,5.784c-40.024,16.205-116.844,50.631-187.534,84.421 l134.321-31.309l73.291-18.389L339.674,213.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00FAB0",
    d: "M366.636,381.46l-0.464-2.887c-16.175,15.583-37.338,29.826-62.451,41.591 c-10.749,58.029-22.263,134.24-23.976,208.898c-3.336,145.501,88.743,45.077,109.935,3.354 c13.369-26.318-6.526-157.581-23.044-250.96V381.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00FAB0",
    d: "M244.157,441.17l-43.173,10.833c-62.571,15.7-122.029,13.72-162.831-2.7 c-19.168,26.592,6.306,51.537,11.038,72.016c6.12,26.512,37.915,119.256,105.547,141.222 c42.742,13.888,98.586-130.447,134.014-235.841C274.863,432.317,259.96,437.202,244.157,441.17z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworksshape);
export default __webpack_public_path__ + "static/media/howitworksshape.63b415d6f5ce90ae7f2608fff7df5155.svg";
export { ForwardRef as ReactComponent };